export const getVisitsFinancialSummaryChartLabels = (t: Function): string[] => [
  t('financialReports.employees.pendingVisits'),
  t('visit.table.completedVisits'),
  t('drawer.sidebar.allVisits'),
];
